import { render, staticRenderFns } from "./cleartoken.vue?vue&type=template&id=8f5dcda4&scoped=true&"
import script from "./cleartoken.vue?vue&type=script&lang=js&"
export * from "./cleartoken.vue?vue&type=script&lang=js&"
import style0 from "./cleartoken.vue?vue&type=style&index=0&id=8f5dcda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5dcda4",
  null
  
)

export default component.exports